import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

import Page from './pages/Page';
import ConnectedCovid19Page from './containers/ConnectedCovid19Page';

import {
    BASE_PATH,
    COUNTRY_PATH,
    FINANCIAL_RELIEF_PATH,
    REGION_PATH,
} from './constants';

const getRoutes = (appProps) => {
    const BasePageWithAppProps = (props) => <Page {...appProps} {...props} />;

    const Covid19PageWithAppProps = (props) => (
        <ConnectedCovid19Page {...appProps} {...props} />
    );

    return (
        <Route path={BASE_PATH} component={BasePageWithAppProps}>
            <IndexRoute component={Covid19PageWithAppProps} />
            <Route
                path={FINANCIAL_RELIEF_PATH}
                component={Covid19PageWithAppProps}
            />
            <Route path={COUNTRY_PATH} component={Covid19PageWithAppProps} />
            <Route path={REGION_PATH} component={Covid19PageWithAppProps} />
        </Route>
    );
};

export default getRoutes;
